export const config = {
  APP_NAME: "Supplies&Stuff Customer",
  APP_SUPPORT_EMAIL: "support@suppliesandstuff.com",
  APP_NAME_FRIENDLY: "Supplies&Stuff Customer Portal",
  API_ORIGIN: import.meta.env.VITE_API_ORIGIN,
  /** Local storage keys */
  LS: {
    TOKEN: "bearer-token",
    ACTIVE_COMPANY_ID: "active-company-id",
  },
  HEADERS: {
    ACTIVE_COMPANY_ID: "X-Active-Company-Id",
  },
  TZ: import.meta.env.PROD ? "America/Los_Angeles" : "Europe/Kyiv",
  PAGE_UNILIMITED: 1000,
  PHOTOS_SERVICE_ORIGIN: import.meta.env.VITE_PHOTOS_SERVICE_ORIGIN,
};
